
import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';

const Footer = () => {
  const { theme } = useContext(ThemeContext);
  const currentYear = new Date().getFullYear();

  const textClasses = theme === 'dark' ? 'text-gray-400' : 'text-gray-600';
  const linkClasses = `hover:text-blue-500 transition-colors duration-300 ${textClasses}`;
  const iconClasses = `text-2xl ${linkClasses}`;

  return (
    <footer className={`py-8 px-4 ${theme === 'dark' ? 'bg-gray-900' : 'bg-gray-100'}`}>
      <div className="container mx-auto text-center">
        <div className="flex justify-center space-x-6 mb-4">
          <a href="https://www.facebook.com/CYDceiling?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer" className={iconClasses}>
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://wa.me/995598028028" target="_blank" rel="noopener noreferrer" className={iconClasses}>
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>
        <p className={textClasses}>&copy; {currentYear} StudioCeiling. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
